import { apiPost } from "../client";
import { useMutation } from "@tanstack/react-query";
import type { IRetakeExamProgress } from "./types";

export const createRetake = async (originalExamProgressId: string) => {
  const response = await apiPost<IRetakeExamProgress>(
    `/exam_progress/${originalExamProgressId}/retake`
  );
  return response.data;
};

export const useMutationCreateRetake = () => {
  return useMutation({
    mutationFn: createRetake,
  });
}; 